function Arguments(argumentsObject) {
  return Array.prototype.slice.call(argumentsObject);
}

module.exports = Arguments;
